import React from 'react';

const WhatsAppButton = () => {
  const phoneNumber = "919824091979";
  const message = encodeURIComponent("Hello, I am interested in your services");
  
  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-8 left-8 z-50 bg-white hover:bg-gray-50 border-2 border-green-500 text-green-600 p-3 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
      aria-label="Connect on WhatsApp"
    >
      <img 
        src="https://toppng.com/public/uploads/preview/whatsapp-icon-vector-free-download-11574065507m63jptkf4q.png"
        alt="WhatsApp"
        className="w-7 h-7 object-contain"
      />
    </button>
  );
};

export default WhatsAppButton;
